<template>
  <v-layout class="form-wrapper mt-1" wrap>
    <v-flex xs12 sm4>
      <v-radio-group
        v-model="contact.access"
        :rules="[required]"
        :name="`contacts.${index}.access`"
        :error-messages="errors[`contacts.${index}.access`]"
        @blur="checkForErrors(`contacts.${index}.access`)">
        <v-radio value="limited">
          <div slot="label" style="display: flex; align-items: center; height: 28px">
            {{ $t('limited_access') }}
            <v-tooltip right lazy>
              <v-icon slot="activator" class="ml-1">help</v-icon>
              <div>
                {{ $t('limited_access_allows') }}:
                <ul>
                  <li>{{ $t('view_rented_equipment') }};</li>
                  <li>{{ $t('view_construction_sites') }};</li>
                  <li>{{ $t('order_equipment') }};</li>
                  <li>{{ $t('edit_order') }};</li>
                  <li>{{ $t('cancel_order') }};</li>
                  <li>{{ $t('return_equipment') }};</li>
                  <li>{{ $t('set_favourite_construction_sites') }};</li>
                  <li>{{ $t('edit_personal_info') }};</li>
                </ul>
              </div>
            </v-tooltip>
          </div>
        </v-radio>
        <v-radio value="unlimited">
          <div slot="label" style="display: flex; align-items: center; height: 28px">
            {{ $t('unlimited_access') }}
            <v-tooltip right lazy>
              <v-icon slot="activator" class="ml-1">help</v-icon>
              <div>
                {{ $t('unlimited_access_allows') }}:
                <ul>
                  <li>{{ $t('view_rented_equipment') }};</li>
                  <li>{{ $t('view_construction_sites') }};</li>
                  <li>{{ $t('order_equipment') }};</li>
                  <li>{{ $t('edit_order') }};</li>
                  <li>{{ $t('cancel_order') }};</li>
                  <li>{{ $t('return_equipment') }};</li>
                  <li>{{ $t('set_favourite_construction_sites') }};</li>
                  <li>{{ $t('edit_personal_info') }};</li>
                  <li>{{ $t('create_construction_sites') }};</li>
                  <li>{{ $t('edit_construction_sites') }};</li>
                  <li>{{ $t('view_statistics') }};</li>
                  <li>{{ $t('view_invoices') }}.</li>
                </ul>
              </div>
            </v-tooltip>
          </div>
        </v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex xs12 sm8>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-model="contact.email"
            :label="$t('email_address')"
            :error-messages="errors[`contacts.${index}.email`]"
            :rules="[required]"
            :name="`contacts.${index}.email`"
            @blur="checkForErrors(`contacts.${index}.email`)"
          />
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field
            v-model="contact.first_name"
            :label="$t('first_name')"
            :error-messages="errors[`contacts.${index}.first_name`]"
            :name="`contacts.${index}.first_name`"
            :rules="[required]"
            @blur="checkForErrors(`contacts.${index}.first_name`)"
          />
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field
            v-model="contact.last_name"
            :label="$t('last_name')"
            :error-messages="errors[`contacts.${index}.last_name`]"
            :name="`contacts.${index}.last_name`"
            :rules="[required]"
            @blur="checkForErrors(`contacts.${index}.last_name`)"
          />
        </v-flex>
        <v-flex sm4 xs12>
          <v-text-field
            v-model="contact.phone"
            :label="$t('phone')"
            :error-messages="errors[`contacts.${index}.phone`]"
            :name="`contacts.${index}.phone`"
            :rules="[required]"
            @blur="checkForErrors(`contacts.${index}.phone`)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations } from 'vuex';
import formMixin from '../mixins/form-mixin';

export default {
  name: 'EmployeeForm',

  mixins: [formMixin],

  props: {
    contact: Object,
    errors: Object,
    index: Number,
  },

  methods: {
    ...mapMutations({
      clearErrors: 'clients/clearErrors',
    }),

    checkForErrors(field) {
      if (this.errors[field].length) {
        this.clearErrors(field);
      }
    },
  },
};
</script>
